import { useParams } from 'react-router-dom'

import { DocumentDetails as DocumentDetailsContainer } from '../containers/content/documents'

const Document = () => {
  const { id } = useParams()
  if(!id) return <div>Invalid document id</div>
  return <DocumentDetailsContainer id={id} />
}

export default Document
